import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { SET_ERROR } from '../../data/store/ui/ui.actions';

export const errorHttpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);
  const store = inject(Store);

  const createErrorPathCode = (route: string, errorCode: string) => {
    return { route, errorCode };
  };

  const _errorCodeApi = [
    createErrorPathCode('/login', 'LOG'),
    createErrorPathCode('/validar', 'LOG2'),
    createErrorPathCode('/actualizar-pantalla', 'LOG3'),
    createErrorPathCode('/re-enviar-codigo-validacion', 'LOG4'),
    createErrorPathCode('/tu-nombre', 'NOMB'),
    createErrorPathCode('/fecha-nacimiento', 'fNAC'),
    createErrorPathCode('/donde-naciste', 'lNAC'),
    createErrorPathCode('/estado-civil-genero', 'EDOc'),
    createErrorPathCode('/curp', 'CURP'),
    createErrorPathCode('/validar-curp', 'vCURP'),
    createErrorPathCode('/tu-direccion', 'DIR'),
    createErrorPathCode('/tu-calle', 'DIRc'),
    createErrorPathCode('/sobre-ti', 'GDOe'),
    createErrorPathCode('/ingreso-mensual', 'ING'),
    createErrorPathCode('/origen-ingreso-mensual', 'oING'),
    createErrorPathCode('/celular', 'CEL'),
    createErrorPathCode('/validar-codigo-celular', 'vCEL'),
    createErrorPathCode('/reenviar-codigo-verificacion-celular', 'rCOD'),
    createErrorPathCode('/autorizaciones', 'AUTO'),
    createErrorPathCode('/eleccion-producto', 'ePRO'),
    createErrorPathCode('/usuario-facebook', 'lFB'),
    createErrorPathCode('/creditos-solicitud', 'CRED'),
    createErrorPathCode('/referencias-prospecto', 'REF'),
    createErrorPathCode('/preparate-prospecto', 'pPRO'),
    createErrorPathCode('/tipo-identificacion-prospecto', 'tID'),
    createErrorPathCode('/ine-frente-prospecto', 'fINE'),
    createErrorPathCode('/pasaporte-prospecto', 'PASS'),
    createErrorPathCode('/fm2-fm3-prospecto', 'EFM'),
    createErrorPathCode('/selfie-prospecto', 'SELF'),
    createErrorPathCode('/prospecto-fecebook-url', 'FBURl'),
    createErrorPathCode('/actualizar-pantalla-solicitud', 'ACTp'),
    createErrorPathCode('/catalogo-paises', 'CATPAI'),
    createErrorPathCode('/catalogo-nacionalidades', 'CATNAC'),
    createErrorPathCode('/catalogo-estado-civil', 'CATEC'),
    createErrorPathCode('/catalogo-estados-mexico', 'CATEDO'),
    createErrorPathCode('/catalogo-nivel-estudios', 'CATNE'),
    createErrorPathCode('/catalogo-grado-estudios', 'CATGE'),
    createErrorPathCode('/catalogo-tipo-vialidad', 'CATVIA'),
    createErrorPathCode('/cual-es-el-origen-de-tus-ingresos', 'CATOI1'),
    createErrorPathCode('/concepto-origen-de-tus-ingresos', 'CATOI2'),
    createErrorPathCode('/catalogos-origen-ingresos', 'CATOI3'),
    createErrorPathCode('/catalogo-tipo-referencia-prospecto', 'CATtR'),
    createErrorPathCode('/validacion-gobierno', 'VALGob'),
    createErrorPathCode('/continuar', 'REDva'),
    createErrorPathCode('/regresar', 'REGpa'),
    createErrorPathCode('/incode-wf', 'INCscr'),
    createErrorPathCode('/verificacion-email', 'VEmail'),
    createErrorPathCode('/ine_frontal_incode', 'INinc'),
    createErrorPathCode('/datos_ine_frontal_incode', 'DINinc'),
    createErrorPathCode('/ine_reverso_incode', 'REinc'),
    createErrorPathCode('/datos_ine_reverso_incode', 'DREinc'),
    createErrorPathCode('/selfie_incode', 'SEinc'),
    createErrorPathCode('/datos_selfie_incode', 'DSEinc'),
    createErrorPathCode('/selfie_extranjero_incode', 'ISXnc'),
    createErrorPathCode('/datos_selfie_extranjero_incode', 'DSXinc'),
    createErrorPathCode('/pasaporte_frente_extranjero_incode', 'PFXinc'),
    createErrorPathCode('/datos_pasaporte_frente_extranjero_incode', 'DPXinc'),
    createErrorPathCode('/pasaporte_frente_incode', 'DPinc'),
    createErrorPathCode('/fm2_fm3_incode', 'FMinc'),
    createErrorPathCode('/datos_fm2_fm3_incode', 'DFMinc'),
    createErrorPathCode('https://api.ipify.org/?format=json', 'LOGIP'),
    createErrorPathCode('/dispositivo-prospecto', 'DISpro'),
    createErrorPathCode('/chatbot', 'BOTvx'),
    createErrorPathCode('/verificacion-datos', 'VData'),
    createErrorPathCode('/flags', 'Fdt'),
    createErrorPathCode('/geolocalizacion', 'GEO'),
    createErrorPathCode('www.googleapis.com/geolocation', 'GEOG'),
  ];

  return next(req).pipe(
    catchError(error => {
      let errorMessage = '';
      let errorLocation = '';
      let estatusError = '';
      const indexCode = _errorCodeApi.findIndex(objeto =>
        error.url?.includes(objeto.route)
      );
      if (indexCode > -1) {
        errorLocation = _errorCodeApi[indexCode].errorCode;
      } else {
        errorLocation = '404';
      }

      if (['LOGIP', 'GEOG', 'GEO'].includes(errorLocation)) {
        return next(req).pipe(
          catchError(err => {
            return throwError(() => error);
          })
        );
      }
      estatusError = errorLocation == 'LOGIP' ? 1 : error.status;
      errorMessage = `${error.status} ${error.status}`;
      store.dispatch(
        SET_ERROR({
          uiError: {
            statusError: estatusError,
            errorLocation: errorLocation,
            errorMessage: errorMessage,
          },
        })
      );

      router.navigate(['/error']);
      return throwError(() => errorMessage);
    })
  );
};
